import { fetchAppVersionsForSelectedApp } from './FetchAppVersions';
import { ProjectDetailState } from '../state';
import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { App } from 'data/terra/App';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';

export const SELECT_APP = 'project/apps/select';

export interface SelectAppAction {
  type: typeof SELECT_APP;
  appId: string;
}

export const selectApp = (
  appId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: SELECT_APP,
    appId,
  } as SelectAppAction);
  dispatch(fetchAppVersionsForSelectedApp());
};

export const selectAppDelegate: DelegateMapEntry<
  SelectAppAction,
  ProjectDetailState
> = {
  [SELECT_APP]: (
    state: ProjectDetailState,
    action: SelectAppAction
  ): ProjectDetailState => {
    return {
      ...state,
      selectedApp: state.apps.data?.find((a: App) => a.id === action.appId),
    };
  },
};
